import { render, staticRenderFns } from "./LoadObjectsCheck.vue?vue&type=template&id=2bc60707"
import script from "./LoadObjectsCheck.vue?vue&type=script&lang=js"
export * from "./LoadObjectsCheck.vue?vue&type=script&lang=js"
import style0 from "./LoadObjectsCheck.vue?vue&type=style&index=0&id=2bc60707&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports